<div class="multi-step-form">
  <div class="msf-header-section">
    <div class="msf-title">{{ title() }}</div>
    <div class="percentage-complete-container">
      <div class="percentage-header">
        <span class="percentage-complete-text" i18n="@@form-step"> Step {{ currentStepIndex() + 1 }} of {{ steps().length }} </span>
        <span class="percentage-complete-text">{{ calculateMFPercentage() + '%' }}</span>
      </div>
      <div class="percentage-complete-bar">
        <div class="percentage-complete-value" [style.width]="calculateMFPercentage() + '%'"></div>
      </div>
    </div>
  </div>

  <div class="msf-step" *ngIf="steps()?.length > 0">
    <div class="msf-content-section">
      <div class="stepper-container">
        <gpd-stepper
          [items]="stepperItems()"
          [(selectedIndex)]="currentStepIndex"
          (selectionChanged)="onStepperSelectionChanged($event)"
        ></gpd-stepper>
      </div>
      <dx-multi-view
        [(selectedIndex)]="currentStepIndex"
        width="100%"
        height="100%"
        [draggable]="false"
        [swipeEnabled]="false"
        class="msf-multi-view"
      >
        <dxi-multi-view-item *ngFor="let step of steps()">
          <div *dxTemplate class="msf-step-pane">
            <dx-validation-group [id]="'validation-group-' + step.id">
              <div class="msf-form-section">
                <div class="step-description" *ngIf="step.description">
                  {{ step.description }}
                </div>
                <div class="step-content">
                  <ng-container
                    *ngTemplateOutlet="
                      step.template;
                      context: {
                        validationGroup: 'validation-group-' + step.id,
                      }
                    "
                  ></ng-container>
                </div>
              </div>
            </dx-validation-group>
          </div>
        </dxi-multi-view-item>
      </dx-multi-view>
    </div>
    <div class="msf-actions-section">
      <div class="gpd-button-group">
        <app-gpd-button
          i18n-text="@@cancel"
          text="Cancel"
          type="secondary"
          (onClick)="onCancelBtnClicked($event)"
        ></app-gpd-button>
      </div>
      <div class="gpd-button-group">
        <app-gpd-button
          *ngIf="currentStepIndex() > 0"
          i18n-text="@@back"
          text="Back"
          type="secondary"
          (onClick)="onPreviousBtnClicked($event)"
        ></app-gpd-button>
        <app-gpd-button
          *ngIf="currentStepIndex() < steps().length - 1"
          i18n-text="@@next"
          text="Next"
          [disabled]="isNextButtonDisabled()"
          (onClick)="onNextBtnClicked($event)"
        ></app-gpd-button>
        <app-gpd-button
          *ngIf="currentStepIndex() === steps().length - 1"
          [text]="finishText()"
          type="primary"
          [disabled]="isNextButtonDisabled() || isFinishButtonDisabled()"
          (onClick)="onFinishBtnClicked($event)"
        ></app-gpd-button>
      </div>
    </div>
  </div>
</div>
